const isInputElement = element => {
  return element instanceof HTMLInputElement || element instanceof HTMLSelectElement;
};
export class AutoSubmitForm extends HTMLElement {
  constructor() {
    super(...arguments);
    this.onSubmit = event => {
      var _a;
      const target = event.target;
      if (target instanceof HTMLInputElement && ((_a = target.files) === null || _a === void 0 ? void 0 : _a.length) === 0) {
        return;
      }
      const form = isInputElement(target) ? target.form : target.closest('form');
      const submitter = this.submitter ? form === null || form === void 0 ? void 0 : form.querySelector(this.submitter) : undefined;
      if (form === null || form === void 0 ? void 0 : form.requestSubmit) {
        form.requestSubmit(submitter);
      } else {
        submitter ? submitter.click() : form === null || form === void 0 ? void 0 : form.submit();
      }
    };
  }
  connectedCallback() {
    this.addEventListener('change', this.onSubmit);
  }
  disconnectedCallback() {
    this.removeEventListener('change', this.onSubmit);
  }
  get submitter() {
    return this.getAttribute('submitter') || undefined;
  }
  set submitter(value) {
    if (value) {
      this.setAttribute('submitter', value);
    } else {
      this.removeAttribute('submitter');
    }
  }
}
if (!window.customElements.get('auto-submit-form')) {
  window.AutoSubmitForm = AutoSubmitForm;
  window.customElements.define('auto-submit-form', AutoSubmitForm);
}